import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import SlashCircleIconSvg from './SlashCircleIconSvg'

const SlashCircleIcon = (props: IconProps): ReactElement => (
    <Icon component={SlashCircleIconSvg} {...props} />
)

export default SlashCircleIcon
